import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  public bannerImageSrc = "../../../assets/images/OneCare_banner3_2_EN.png";

  constructor() { }

  ngOnInit(): void {
    this.setBannerImage();
  }

  public setBannerImage() {
    let random = Math.floor(Math.random() * 4);

    if (random == 0) {
      this.bannerImageSrc = "../../../assets/images/OneCare_banner3_2_EN.png"
    } else if(random == 1){
      this.bannerImageSrc = "../../../assets/images/OneCare_banner4_2_EN.png"
    } else if(random == 2){
      this.bannerImageSrc = "../../../assets/images/OneCare_banner5_2_EN.png"
    } else if(random == 3){
      this.bannerImageSrc = "../../../assets/images/OneCare_banner6_2_EN.png"
    }
  }

}
